
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1224"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1224"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5AlLF", function(module, exports) {
"use strict";
(function(a, b) {
    "function" == typeof define && define.amd ? define("tinysort", function() {
        return b;
    }) : a.tinysort = b;
})(window || module || {}, function(a) {
    function c(a, b) {
        for(var c, d = a.length, e = d; e--;)c = d - e - 1, b(a[c], c);
        return a;
    }
    function b(a, b, c) {
        for(var d in b)(c || a[d] === e) && (a[d] = b[d]);
        return a;
    }
    function d(a, b, c) {
        return l.push({
            prepare: a,
            sort: b,
            sortBy: c
        });
    }
    var e = a, f = null, g = window, h = g.document, i = parseFloat, j = /(-?\d+\.?\d*)\s*$/g, k = /(\d+\.?\d*)\s*$/g, l = [], m = function(a) {
        return String.fromCharCode(a);
    }, n = function(a) {
        return Array.from([
            ,
            ,
            , 
        ], function(b, c) {
            return m(a + c);
        });
    }, o = n(0), p = n(4095), q = {
        selector: f,
        order: "asc",
        attr: f,
        data: f,
        useVal: !1,
        place: "org",
        returns: !1,
        cases: !1,
        natural: !1,
        forceStrings: !1,
        ignoreDashes: !1,
        sortFunction: f,
        useFlex: !1,
        emptyEnd: !1,
        console: console
    }, r = 0, s = 0;
    return g.Element && function(a) {
        return a.matches = a.matches || a.msMatchesSelector;
    }(Element.prototype), b(d, {
        loop: c
    }), b(function(a) {
        for(var A = arguments.length, B = Array(1 < A ? A - 1 : 0), C = 1; C < A; C++)B[C - 1] = arguments[C];
        function d(a) {
            var c = !!a.selector, d = c && ":" === a.selector[0], e = b(a || {}, q);
            return L.push(b({
                hasSelector: c,
                hasAttr: e.attr !== f && "" !== e.attr,
                hasData: e.data !== f,
                hasFilter: d,
                sortReturnNumber: "asc" === e.order ? 1 : -1
            }, e));
        }
        function g() {
            c(a, function(a, b) {
                M ? M !== a.parentNode && (N = !1) : M = a.parentNode;
                var c = L[0], d = c.hasFilter, e = c.selector, f = !e || d && a.matches(e) || e && a.querySelector(e), g = f ? I : J, h = g.length, i = {
                    elm: a,
                    pos: b,
                    posn: h
                };
                H.push(i), g.push(i);
            }), K.splice.apply(K, [
                0,
                Number.MAX_SAFE_INTEGER
            ].concat(I));
        }
        function m(e, a, b) {
            for(var f = b(e.toString()), g = b(a.toString()), h = 0; f[h] && g[h]; h++)if (f[h] !== g[h]) {
                var i = +f[h], c = +g[h];
                return i == f[h] && c == g[h] ? i - c : f[h] > g[h] ? 1 : -1;
            }
            return f.length - g.length;
        }
        function n(a) {
            for(var b, c = [], d = 0, e = -1, f = 0, g = void 0, h = void 0; g = (h = a.charAt(d++)).charCodeAt(0);)b = 46 === g || 48 <= g && 57 >= g, b !== f && (c[++e] = "", f = b), c[e] += h;
            return c;
        }
        function t(d, a) {
            var b = 0;
            0 !== s && (s = 0);
            for(var e = function() {
                var e = L[s], f = e.ignoreDashes ? k : j;
                c(l, function(a) {
                    return a.prepare && a.prepare(e);
                });
                var g = !1, h = y(d, e), o = y(a, e);
                if (e.sortFunction) b = e.sortFunction(d, a);
                else if ("rand" === e.order) b = .5 > Math.random() ? 1 : -1;
                else if (h === o) b = 0;
                else {
                    if (!e.forceStrings) {
                        var p = !!z(h) && h && h.match(f), q = !!z(o) && o && o.match(f);
                        if (p && q) {
                            var r = h.substr(0, h.length - p[0].length), t = o.substr(0, o.length - q[0].length);
                            r == t && (g = !0, h = i(p[0]), o = i(q[0]));
                        }
                    }
                    b = e.natural && (isNaN(h) || isNaN(o)) ? m(h, o, n) : h < o ? -1 : h > o ? 1 : 0;
                }
                c(l, function(a) {
                    var c = a.sort;
                    return c && (b = c(e, g, h, o, b));
                }), b *= e.sortReturnNumber, 0 === b && s++;
            }; 0 === b && s < r;)e();
            return 0 === b && (b = d.pos > a.pos ? 1 : -1), b;
        }
        function u() {
            var a = I.length, b = a === H.length, c = a === M.children.length, d = L[0], e = d.place, f = d.console;
            if (N && b && c) Q ? I.forEach(function(a, b) {
                return a.elm.style.order = b;
            }) : M ? M.appendChild(v()) : f && f.warn && f.warn("parentNode has been removed");
            else {
                var g = "start" === e, h = "end" === e, i = "first" === e;
                if ("org" === e) I.forEach(w), I.forEach(function(a, b) {
                    return x(K[b], a.elm);
                });
                else if (g || h) {
                    var j = K[g ? 0 : K.length - 1], k = j && j.elm.parentNode, l = k && (g && k.firstChild || k.lastChild);
                    l && (l !== j.elm && (j = {
                        elm: l
                    }), w(j), h && k.appendChild(j.ghost), x(j, v()));
                } else if (i || "last" === e) {
                    var m = K[i ? 0 : K.length - 1];
                    x(w(m), v());
                }
            }
        }
        function v() {
            return I.forEach(function(a) {
                return G.appendChild(a.elm);
            }), G;
        }
        function w(a) {
            var b = a.elm, c = h.createElement("div");
            return a.ghost = c, b.parentNode.insertBefore(c, b), a;
        }
        function x(a, b) {
            var c = a.ghost, d = c.parentNode;
            d.insertBefore(b, c), d.removeChild(c), delete a.ghost;
        }
        function y(a, b) {
            var c, d = a.elm, g = b.selector;
            g && (b.hasFilter ? !d.matches(g) && (d = f) : d = d.querySelector(g)), b.hasAttr ? c = d.getAttribute(b.attr) : b.useVal ? c = d.value || d.getAttribute("value") : b.hasData ? c = d.getAttribute("data-" + b.data) : d && (c = d.textContent), z(c) && (!b.cases && (c = c.toLowerCase()), c = c.replace(/\s+/g, " "));
            var h = [
                e,
                f,
                ""
            ].indexOf(c);
            return -1 !== h && (c = (b.emptyEnd ? p : o)[h]), c;
        }
        function z(a) {
            return "string" == typeof a;
        }
        var D = B[0] || {};
        z(a) && (a = h.querySelectorAll(a));
        var E = Object.assign({}, q, D || {}), F = E.console;
        0 === a.length && F && F.warn && F.warn("No elements to sort");
        var G = h.createDocumentFragment(), H = [], I = [], J = [], K = [], L = [], M = void 0, N = !0, O = a.length && a[0].parentNode, P = O.rootNode !== document, Q = a.length && (D === e || !1 !== D.useFlex) && !P && -1 !== getComputedStyle(O, null).display.indexOf("flex");
        return r = function(a) {
            return 0 === a.length && d({}) || c(a, function(a) {
                return d(z(a) ? {
                    selector: a
                } : a);
            }).length;
        }(B), g(), I.sort(D.sortFunction || t), u(), I.map(function(a) {
            return a.elm;
        });
    }, {
        plugin: d,
        defaults: q
    });
}());

});

parcelRegister("gCiTj", function(module, exports) {

$parcel$export(module.exports, "cart", () => cart);

var $c2gn4 = parcelRequire("c2gn4");
const cartModal = document.querySelector("#cart-modal");
function cart() {
    PetiteVue.createApp({
        products: (/*@__PURE__*/$parcel$interopDefault($c2gn4)),
        filterLiveRegion: document.querySelector("#filter-live-region"),
        table: document.querySelector("[data-cart]"),
        cartCaptionTotal: document.querySelector("[data-cart-caption-total]"),
        cart: JSON.parse(localStorage.getItem("cart")) || [],
        amount: 1,
        invoiceDataHidden: false,
        sum: 0,
        totalCartItems: 0,
        sortBy: "id",
        sortDirection: "asc",
        giftwrapPrice: 299,
        get sortedProducts () {
            return this.products.sort((p1, p2)=>{
                let modifier = 1;
                if (this.sortDirection === "desc") modifier = -1;
                if (p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier;
                if (p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
                return 0;
            });
        },
        updateItemPrice (id) {
            let product = this.getCartItemById(id)[0];
            product.amount = parseFloat(event.target.value);
            this.persistCart();
            this.getLocalSum(product, parseFloat(event.target.value));
            this.getLocalTotal(product);
            this.updateCartItemAmount();
            this.updateTotalSum();
            this.filterLiveRegion.textContent = "Neuer Preis: \u20AC" + this.getLocalTotal(product) / 100 + ". Neuer Gesamtpreis des Warenkorbs: \u20AC " + this.sum / 100;
            this.cartCaptionTotal.textContent = String(this.sum / 100);
        },
        whenMounted () {
            this.updateCartItemAmount();
            this.updateTotalSum();
            setTimeout(()=>{
                this.cartCaptionTotal.textContent = String(this.sum / 100);
            }, 500);
        },
        updateCartItemAmount () {
            let cartItemAmount = 0;
            this.cart.forEach((cI)=>{
                cartItemAmount += cI.amount;
            });
            this.totalCartItems = cartItemAmount;
        },
        updateTotalSum () {
            let theSum = 0;
            this.cart.forEach((product)=>{
                theSum += product.price * product.amount;
                if (product.giftwrap) theSum = theSum + this.giftwrapPrice;
            });
            this.sum = theSum;
        },
        getLocalSum (cartItem, amount) {
            if (cartItem && amount) {
                let returnVal = cartItem.price * amount;
                cartItem.localTotal = returnVal;
                return returnVal;
            }
        },
        getLocalTotal (product) {
            let price;
            price = product.localTotal;
            if (product.giftwrap) price += this.giftwrapPrice;
            return price;
        },
        localSum (cartItem, amount) {
            return this.getLocalSum(cartItem, amount);
        },
        isInCart (id) {
            return this.cart.find((x)=>x.id === id);
        },
        changeSort (e) {
            switch(e.target.value){
                case "name-desc":
                    this.sortDirection = "desc";
                    this.sort("name");
                    this.filterLiveRegion.textContent = "Sortiert nach: Name, Z bis A";
                    break;
                case "name-asc":
                    this.sortDirection = "asc";
                    this.sort("name");
                    this.filterLiveRegion.textContent = "Sortiert nach: Name, A bis Z";
                    break;
                case "price-asc":
                    this.sortDirection = "asc";
                    this.sort("price");
                    this.filterLiveRegion.textContent = "Sortiert nach: Preis, g\xfcnstigste zuerst";
                    break;
                case "price-desc":
                    this.sortDirection = "desc";
                    this.sort("price");
                    this.filterLiveRegion.textContent = "Sortiert nach: Preis, teuerste zuerst";
                    break;
                case "":
                    this.sortDirection = "asc";
                    this.sort("id");
                    this.filterLiveRegion.textContent = "Sortierung zur\xfcckgesetzt";
                    break;
            }
        },
        getProductById (id) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($c2gn4))).filter((product)=>product.id === id);
        },
        getCartItemById (id) {
            return this.cart.filter((product)=>product.id === id);
        },
        persistCart () {
            localStorage.setItem("cart", JSON.stringify(this.cart));
        },
        toggleCartItem (productId) {
            let product = this.getProductById(productId);
            // Wenn bereits im Warenkorb, entferne den Artikel, aktualisiere die Summe, gib eine entsprechende Meldung in der Live Region aus und persistiere den neuen Warenkorb in Local Storage
            if (this.cart.find((x)=>x.id === productId)) {
                this.cart = this.cart.filter((n)=>n.id !== product[0].id);
                this.persistCart();
                this.updateTotalSum();
                this.filterLiveRegion.textContent = "Artikel " + product[0].name + " entfernt. Neuer Gesamtpreis des Warenkorbs: \u20AC " + this.sum / 100;
                setTimeout(()=>{
                    this.cartCaptionTotal.textContent = String(this.sum / 100);
                }, 100);
                // Fokussiere die Warenkorbtabelle, sodass ihr zugänglicher Name in Form einer aktualisierten <caption> ausgegeben wird
                this.$refs.cart.focus();
            } else {
                // Wenn nicht im Warenkorb, ergänze, aktualisiere die Summe, gib eine entsprechende Meldung in der Live Region aus und persistiere den neuen Warenkorb in Local Storage
                product[0].localTotal = product[0].price;
                this.cart.push(product[0]);
                this.updateTotalSum();
                this.filterLiveRegion.textContent = "Artikel " + product[0].name + " erg\xe4nzt. Neuer Gesamtpreis des Warenkorbs: \u20AC " + this.sum / 100;
                this.persistCart();
                cartModal.showModal();
            }
            this.getLocalTotal(product);
            this.updateCartItemAmount();
            setTimeout(()=>{
                this.cartCaptionTotal.textContent = String(this.sum / 100);
            }, 100);
        },
        toggleGiftWrap (id) {
            let item = this.getCartItemById(id)[0];
            item.giftwrap = !item.giftwrap;
            this.persistCart();
            this.updateTotalSum();
            let addedOrRemoved = item.giftwrap ? "hinzugef\xfcgt" : "entfernt";
            this.filterLiveRegion.textContent = "Geschenkverpackung " + addedOrRemoved + ". Neuer Preis: \u20AC" + this.getLocalTotal(item) / 100 + ". Neuer Gesamtpreis des Warenkorbs: \u20AC " + this.sum / 100;
        },
        hasGiftwrap (id) {
            if (this.getCartItemById(id)[0]) return this.getCartItemById(id)[0].giftwrap;
        },
        sort: function(s) {
            if (s === this.sortBy) this.sortDirection = this.sortDirection === "asc" ? "asc" : "desc";
            this.sortBy = s;
        }
    }).mount();
}
const cartDialog = document.querySelector("#cart-modal");
cartDialog.addEventListener("click", (event1)=>{
    if (event1.target.nodeName === "DIALOG") cartDialog.close();
});

});
parcelRegister("c2gn4", function(module, exports) {
module.exports = JSON.parse('[{"id":1,"name":"Bart\xf6l","in_stock":3,"price":999,"amount":1,"localTotal":0,"giftwrap":false,"img_url":"https://marcus-herrmann.com/dateien/ecbf/bartoel.jpg","img_alt":"Drei kleine Fl\xe4schchen Bart\xf6l, braun."},{"id":2,"name":"Podcast-Kopfh\xf6rer","in_stock":30,"price":2499,"amount":1,"localTotal":0,"giftwrap":false,"img_url":"https://marcus-herrmann.com/dateien/ecbf/kopfhoerer.jpg","img_alt":"Schwarze Kopfh\xf6rer, kabellos."},{"id":3,"name":"Smartphone-H\xfclle","in_stock":13,"price":1199,"amount":1,"localTotal":0,"giftwrap":false,"img_url":"https://marcus-herrmann.com/dateien/ecbf/smart-huelle.jpg","img_alt":"Bunte Smartpone-H\xfclle in t\xfcrkisen, wei\xdfen und blauen groben Pinselstrichen."},{"id":4,"name":"Loser Gr\xfcner Tee","in_stock":5,"price":599,"amount":1,"giftwrap":false,"img_url":"https://marcus-herrmann.com/dateien/ecbf/loser-tee.jpg","img_alt":"Zwei Tassen mit Tee. Links gr\xfcner Tee, rechts Matcha. Dazwischen loser gr\xfcner Tee."},{"id":5,"name":"Handtasche","in_stock":3,"price":5999,"amount":1,"localTotal":0,"giftwrap":false,"img_url":"https://marcus-herrmann.com/dateien/ecbf/handtasche.jpg","img_alt":"Braune Lederhandtasche"},{"id":6,"name":"Armband","in_stock":30,"price":3499,"amount":1,"localTotal":0,"giftwrap":false,"img_url":"https://marcus-herrmann.com/dateien/ecbf/armband.jpg","img_alt":"Armband in martitimen Design, mit einem dominanten goldenen Anker."},{"id":7,"name":"Yoga-Zubeh\xf6r","in_stock":13,"price":1999,"amount":1,"localTotal":0,"giftwrap":false,"img_url":"https://marcus-herrmann.com/dateien/ecbf/yoga-zubehoer.jpg","img_alt":"Yogamatte, zusammengerollt, neben zwei unterschiedlich hohen Yoga-Bl\xf6cken."},{"id":8,"name":"T-Shirt Baumwolle","in_stock":5,"price":2599,"amount":1,"giftwrap":false,"img_url":"https://marcus-herrmann.com/dateien/ecbf/t-shirt.jpg","img_alt":"Blau-graues T-Shirt auf einem Kleiderb\xfcgel."}]');

});


/* Folgendes ist ein nur leicht angepasstes https://github.com/metageeky/mega-menu
unter https://www.mozilla.org/en-US/MPL/2.0/ */ var $81e41802ed93763f$exports = {};
"use strict";
$81e41802ed93763f$exports = function(el, onOver, onOut) {
    var x, y, pX, pY;
    var mouseOver = false;
    var focused = false;
    var h = {}, state = 0, timer = 0;
    var options = {
        sensitivity: 7,
        interval: 100,
        timeout: 0,
        handleFocus: false
    };
    function delay(el, e) {
        if (timer) timer = clearTimeout(timer);
        state = 0;
        return focused ? undefined : onOut.call(el, e);
    }
    function tracker(e) {
        x = e.clientX;
        y = e.clientY;
    }
    function compare(el, e) {
        if (timer) timer = clearTimeout(timer);
        if (Math.abs(pX - x) + Math.abs(pY - y) < options.sensitivity) {
            state = 1;
            return focused ? undefined : onOver.call(el, e);
        } else {
            pX = x;
            pY = y;
            timer = setTimeout(function() {
                compare(el, e);
            }, options.interval);
        }
    }
    // Public methods
    h.options = function(opt) {
        var focusOptionChanged = opt.handleFocus !== options.handleFocus;
        options = Object.assign({}, options, opt);
        if (focusOptionChanged) options.handleFocus ? addFocus() : removeFocus();
        return h;
    };
    function dispatchOver(e) {
        mouseOver = true;
        if (timer) timer = clearTimeout(timer);
        el.removeEventListener("mousemove", tracker, false);
        if (state !== 1) {
            pX = e.clientX;
            pY = e.clientY;
            el.addEventListener("mousemove", tracker, false);
            timer = setTimeout(function() {
                compare(el, e);
            }, options.interval);
        }
        return this;
    }
    function dispatchOut(e) {
        mouseOver = false;
        if (timer) timer = clearTimeout(timer);
        el.removeEventListener("mousemove", tracker, false);
        if (state === 1) timer = setTimeout(function() {
            delay(el, e);
        }, options.timeout);
        return this;
    }
    function dispatchFocus(e) {
        if (!mouseOver) {
            focused = true;
            onOver.call(el, e);
        }
    }
    function dispatchBlur(e) {
        if (!mouseOver && focused) {
            focused = false;
            onOut.call(el, e);
        }
    }
    function addFocus() {
        el.addEventListener("focus", dispatchFocus, false);
        el.addEventListener("blur", dispatchBlur, false);
    }
    function removeFocus() {
        el.removeEventListener("focus", dispatchFocus, false);
        el.removeEventListener("blur", dispatchBlur, false);
    }
    h.remove = function() {
        if (!el) return;
        el.removeEventListener("mouseover", dispatchOver, false);
        el.removeEventListener("mouseout", dispatchOut, false);
        removeFocus();
    };
    if (el) {
        el.addEventListener("mouseover", dispatchOver, false);
        el.addEventListener("mouseout", dispatchOut, false);
    }
    return h;
};


window.addEventListener("load", function(event) {
    // REWRITE NAV TO BE CLOSEST megamenu
    let megamenu = document.querySelector(".mega-menu");
    let responsiveWidth = parseInt(megamenu.getAttribute("data-responsive-width"));
    // toggle button for the responsive menu
    let responsive = megamenu.querySelector("button.responsive-toggle");
    responsive.addEventListener("click", function(evt) {
        // open menu
        if (evt.target.getAttribute("aria-expanded") == "false") {
            evt.target.setAttribute("aria-expanded", "true");
            megamenu.setAttribute("data-menu-state", "focus");
        } else {
            evt.target.setAttribute("aria-expanded", "false");
            megamenu.setAttribute("data-menu-state", "closed");
        }
    });
    // events for the top-level menu buttons for dropdowns
    let triggers = megamenu.querySelectorAll("button.mega-menu-toggle");
    const urlParams = new URLSearchParams(window.location.search);
    for (let e of triggers){
        //click events for the top-level menu buttons for dropdowns
        // Wenn kein Debug Parameter, der eine Nur-Hover-Navi auf dem Desktop simulieren soll, oder unabhängig davon mobil:
        if (urlParams.get("debug") !== "nur-hover-hauptnav" || document.body.classList.contains("mobile")) e.addEventListener("click", function(evt) {
            let opened_menu = megamenu.querySelector('.mega-menu .mega-menu-toggle[aria-expanded="true"]');
            // in the case of hover open, a click just switches the state to focus open
            // only happens in non-responsive mode
            if (megamenu.getAttribute("data-menu-state") == "hover") {
                megamenu.setAttribute("data-menu-state", "focus");
                responsive.setAttribute("aria-expanded", "true");
                evt.target.focus();
                return;
            }
            // close any sub menus opened previously
            if (opened_menu != null && evt.target != opened_menu) // close other opened_menu
            opened_menu.setAttribute("aria-expanded", "false");
            // open menu
            if (evt.target.getAttribute("aria-expanded") == "false") {
                evt.target.setAttribute("aria-expanded", "true");
                megamenu.setAttribute("data-menu-state", "focus");
                responsive.setAttribute("aria-expanded", "true");
            } else {
                evt.target.setAttribute("aria-expanded", "false");
                megamenu.setAttribute("data-menu-state", "closed");
                if (document.body.offsetWidth > responsiveWidth) responsive.setAttribute("aria-expanded", "false");
            }
        });
        //}
        // hover
        $81e41802ed93763f$exports(e, function(evt) {
            if (document.body.offsetWidth <= responsiveWidth) return;
            // ignore hover effects if menu has been opened by focus
            if (megamenu.getAttribute("data-menu-state") == "focus") return;
            megamenu.setAttribute("data-menu-state", "hover");
            evt.target.setAttribute("aria-expanded", "true");
        }, function(evt) {
            if (document.body.offsetWidth <= responsiveWidth) return;
            // if a focus in the menu has happened, take precedent
            if (megamenu.getAttribute("data-menu-state") == "focus") return;
            // if relatedTarget is an open mega-sub-menu, don't close
            if (evt.relatedTarget != null && evt.relatedTarget.classList.contains("mega-sub-menu")) return;
            megamenu.setAttribute("data-menu-state", "closed");
            evt.target.setAttribute("aria-expanded", "false");
        }).options({
            timeout: 200,
            interval: 50
        });
    }
    // blur used to detect if focus has moved out of the mega menu
    let focusables = megamenu.querySelectorAll(".mega-sub-menu a, button.mega-menu-toggle");
    for (let e of focusables)e.addEventListener("blur", function(evt) {
        if (megamenu.getAttribute("data-menu-state") != "focus") return;
        // detect window change and don't close things
        if (document.activeElement === this) return;
        // if click on non-clickable, close the menu
        if (evt.relatedTarget == null) {
            megamenu.setAttribute("data-menu-state", "closed");
            megamenu.querySelector('.mega-menu-toggle[aria-expanded="true"]').setAttribute("aria-expanded", "false");
            responsive.setAttribute("aria-expanded", "false");
        } else if (evt.relatedTarget != null && evt.relatedTarget.closest(".mega-menu") == null) {
            megamenu.setAttribute("data-menu-state", "closed");
            megamenu.querySelector('.mega-menu-toggle[aria-expanded="true"]').setAttribute("aria-expanded", "false");
            responsive.setAttribute("aria-expanded", "false");
        }
    });
    let subs = megamenu.querySelectorAll("div.mega-sub-menu");
    for (let e of subs)e.addEventListener("focus", function(evt) {
        // if in hover state and click on the opened menu, switch to focus with focus on toggle
        if (megamenu.getAttribute("data-menu-state") == "hover") {
            megamenu.setAttribute("data-menu-state", "focus");
            evt.target.previousElementSibling.focus();
        } else if (megamenu.getAttribute("data-menu-state") == "focus" && evt.relatedTarget != null) evt.relatedTarget.focus();
    });
    let submenus = document.querySelectorAll("button.mega-menu-toggle + div.mega-sub-menu");
    for (let e of submenus)// handle hovering moving from opened sub-menu to the toggle button that controls it
    e.addEventListener("mouseleave", function(evt) {
        if (document.body.offsetWidth <= responsiveWidth) return;
        if (megamenu.getAttribute("data-menu-state") == "focus") return;
        // target is the div.sub-menu, related target is the toggle button before it
        if (evt.relatedTarget != null && evt.relatedTarget == evt.target.previousElementSibling) return;
        megamenu.setAttribute("data-menu-state", "closed");
        let open_toggle_button = document.querySelector('.mega-menu button[aria-expanded="true"]');
        if (open_toggle_button) open_toggle_button.setAttribute("aria-expanded", "false");
    });
    let menuLinks = document.querySelectorAll("button.mega-menu-toggle + div.mega-sub-menu a");
    for (let e of menuLinks)e.addEventListener("focus", function(evt) {
        // if already having focus in the mega menu, not an issue
        if (megamenu.getAttribute("data-menu-state") == "focus") return;
        // set focus state
        megamenu.setAttribute("data-menu-state", "focus");
        responsive.setAttribute("aria-expanded", "true");
    });
    document.addEventListener("keydown", function(event) {
        if (event.key === "Escape") {
            let menu = document.querySelector(".mega-menu");
            if (document.body.offsetWidth <= responsiveWidth) {
                // responsive mode
                //if there is a focused element, reset focus to responsive toggle
                if (document.activeElement != null && document.activeElement != document.body && document.activeElement.closest(".mega-menu") !== null) menu.querySelector(".responsive-toggle").focus();
                // set all things to close
                for (let b of menu.querySelectorAll('button[aria-expanded="true"]'))b.setAttribute("aria-expanded", "false");
            } else {
                // desktop mode
                let bu1 = menu.querySelector('button.mega-menu-toggle[aria-expanded="true"]');
                let parentButton = event.target.closest(".mega-sub-menu").parentElement.querySelector(".mega-menu-toggle");
                bu1?.setAttribute("aria-expanded", "false");
                bu1?.focus();
                parentButton?.focus();
                menu.setAttribute("data-hover-open", "false");
                menu.setAttribute("data-menu-state", "closed");
            }
        }
    });
});


function $0310234b6907e102$export$40ba32d7e7abefe9(el) {
    el.addEventListener("click", (e)=>{
        let setExpanded = e.target.getAttribute("aria-expanded") === "true" ? "false" : "true";
        if (e.target.tagName === "BUTTON" || e.target.tagName === "A") e.target.setAttribute("aria-expanded", setExpanded);
    });
}
function $0310234b6907e102$export$d0a8044dce8ff2fc() {
    const mq = window.matchMedia("(max-width: 40em)");
    mq.matches ? setToMobile() : setToDesktop();
    mq.addEventListener("change", (event)=>event.matches ? setToMobile() : setToDesktop());
    function setToDesktop() {
        document.body.classList.add("desktop");
        document.body.classList.remove("mobile");
    }
    function setToMobile() {
        document.body.classList.add("mobile");
        document.body.classList.remove("desktop");
    }
}
function $0310234b6907e102$export$18148d12c805c5b0(email) {
    var re = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
    return re.test(email);
}


let $29701fd2209d9ab4$var$mainSearchToggle = document.getElementById("main-search-toggle"), $29701fd2209d9ab4$var$resizeFunc;
$29701fd2209d9ab4$var$mainSearchToggle.setAttribute("aria-expanded", "false");
(0, $0310234b6907e102$export$40ba32d7e7abefe9)($29701fd2209d9ab4$var$mainSearchToggle);
function $29701fd2209d9ab4$var$resizeEndHappened() {
    if (window.getComputedStyle($29701fd2209d9ab4$var$mainSearchToggle).display !== "none") {
        $29701fd2209d9ab4$var$mainSearchToggle.setAttribute("aria-expanded", "false");
        (0, $0310234b6907e102$export$40ba32d7e7abefe9)($29701fd2209d9ab4$var$mainSearchToggle);
    }
}
window.onresize = function() {
    clearTimeout($29701fd2209d9ab4$var$resizeFunc);
    $29701fd2209d9ab4$var$resizeFunc = setTimeout($29701fd2209d9ab4$var$resizeEndHappened, 100);
};


class $48df0946d6b0a87e$var$ComboboxSearch extends HTMLElement {
    constructor(){
        super();
        this.input = this.querySelector('input[type="search"]');
        this.listbox = this.querySelector("#ecbf-combobox-listbox");
        this.listboxOptionContainerProducts = this.querySelector("[data-products-list]");
        this.listboxOptionContainerPages = this.querySelector("[data-pages-list]");
        this.statusElement = this.querySelector("[data-ecbf-combobox-search-status]");
        this.filteredOptions = [];
        this.searchTerm = "";
        this.allProductOptions = [];
        this.allPageOptions = [];
        this.startsOpen = this.getAttribute("starts-open");
        if (this.input) this.input.addEventListener("input", this.debounce((event1)=>{
            this.onChange(event1);
        }, 200).bind(this));
        if (this.startsOpen === "true") this.input.setAttribute("aria-expanded", "true");
        this.getAndHandleAllOptions();
        this.setupEventListeners();
    }
    getAndHandleAllOptions() {
        this.listbox.querySelectorAll("[data-products-list] li").forEach((product)=>this.allProductOptions.push(product));
        this.listbox.querySelectorAll("[data-pages-list] li").forEach((page)=>this.allPageOptions.push(page));
    }
    debounce(fn, wait) {
        let t;
        return (...args)=>{
            clearTimeout(t);
            t = setTimeout(()=>fn.apply(this, args), wait);
        };
    }
    getQuery() {
        return this.input.value.trim();
    }
    setupEventListeners() {
        this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
        this.input.addEventListener("focusout", this.onFocusOut.bind(this));
        this.input.addEventListener("input", this.onInput.bind(this));
        this.addEventListener("keyup", this.onKeyup.bind(this));
    }
    onChange() {
        const newSearchTerm = this.getQuery();
        this.updateSearchForTerm(newSearchTerm);
        this.searchTerm = newSearchTerm;
        if (!this.searchTerm.length) {
            this.close(true);
            return;
        }
        this.listboxOptionContainerProducts.innerHTML = "";
        this.listboxOptionContainerPages.innerHTML = "";
        this.getSearchResults(this.searchTerm);
    }
    updateSearchForTerm(newTerm) {
        const searchForTextElement = this.querySelector("[data-ecbf-combobox-search-search-for-text]");
        searchForTextElement.innerText = newTerm;
    }
    getLowercaseContentWithoutPrice(node) {
        if (node.querySelector("a") !== null) return node.querySelector("a").textContent.toLowerCase();
        else return node.textContent.toLowerCase();
    }
    getSearchResults(searchTerm) {
        this.allProductOptions.forEach((o)=>{
            let option = o;
            if (searchTerm.length === 0 || this.getLowercaseContentWithoutPrice(option).includes(searchTerm) === true) {
                this.filteredOptions.push(option);
                this.listboxOptionContainerProducts.appendChild(option);
            }
        });
        this.allPageOptions.forEach((o)=>{
            let option = o;
            if (searchTerm.length === 0 || this.getLowercaseContentWithoutPrice(option).includes(searchTerm) === true) {
                this.filteredOptions.push(option);
                this.listboxOptionContainerPages.appendChild(option);
            }
        });
        const realTimeOptionAmount1 = this.listboxOptionContainerProducts.querySelectorAll("[data-products-list] li")?.length;
        const realTimeOptionAmount2 = this.listboxOptionContainerPages.querySelectorAll("[data-pages-list] li")?.length;
        if (realTimeOptionAmount1 || realTimeOptionAmount2) {
            if (this.input.value !== "") setTimeout(()=>{
                this.setLiveRegionText(`${realTimeOptionAmount1 + realTimeOptionAmount2} Ergebnisse gefunden: ${realTimeOptionAmount1 ? realTimeOptionAmount1 : 0} Produkte und ${realTimeOptionAmount2 ? realTimeOptionAmount2 : 0} Seiten`);
            }, 1100);
            else this.yieldNoResultsInLiveRegion();
        } else this.yieldNoResultsInLiveRegion();
        this.open();
    }
    yieldNoResultsInLiveRegion() {
        this.setLiveRegionText("Keine Ergebnisse geunden. Bitte versuchen Sie es mit einem anderen Suchbegriff.");
    }
    setLiveRegionText(statusText) {
        this.statusElement.setAttribute("aria-hidden", "false");
        this.statusElement.textContent = statusText;
        setTimeout(()=>{
            this.statusElement.setAttribute("aria-hidden", "true");
        }, 1000);
    }
    onInput() {
        this.open();
    }
    open() {
        if (this.getQuery().length >= 2) setTimeout(()=>{
            this.input.setAttribute("aria-expanded", "true");
        }, 500);
        this.listbox.style.width = this.input.getBoundingClientRect().width + "px";
        this.listbox.style.top = this.input.getBoundingClientRect().height + "px";
    }
    close() {
        this.input.setAttribute("aria-expanded", "false");
    }
    onKeyup() {
        if (!this.getQuery().length) this.close(true);
        event.preventDefault();
        switch(event.code){
            case "ArrowUp":
                this.switchOption("up");
                break;
            case "ArrowDown":
                this.switchOption("down");
                break;
            case "Enter":
                this.selectOption();
                break;
            case "Escape":
                this.close();
                this.input.select();
                break;
            default:
                this.emptyAriaActivedescendant();
        }
    }
    emptyAriaActivedescendant() {
        this.input.setAttribute("aria-activedescendant", "");
    }
    selectOption() {
        const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
        if (selectedOption) selectedOption.click();
    }
    switchOption(direction) {
        if (this.getQuery() === "") return;
        const moveUp = direction === "up";
        const selectedElement = this.querySelector('[aria-selected="true"]');
        // offsetParnet filtert unsichtbare Elemente heraus:
        const allVisibleElements = Array.from(this.querySelectorAll('[role="option"]')).filter((el)=>el.offsetParent !== null);
        let activeElementIndex = 0;
        if (moveUp && !selectedElement) return;
        let selectedElementIndex = -1;
        let i = 0;
        while(selectedElementIndex === -1 && i <= allVisibleElements.length){
            if (allVisibleElements[i] === selectedElement) selectedElementIndex = i;
            i++;
        }
        this.statusElement.textContent = "";
        if (!moveUp && selectedElement) activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
        else if (moveUp) activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
        if (activeElementIndex === selectedElementIndex) return;
        const activeElement = allVisibleElements[activeElementIndex];
        activeElement.setAttribute("aria-selected", true);
        if (selectedElement) selectedElement.setAttribute("aria-selected", false);
        this.input.setAttribute("aria-activedescendant", activeElement.id);
    }
    onFocusOut() {
        setTimeout(()=>{
            if (!this.contains(document.activeElement)) this.close();
        });
    }
    onFormSubmit() {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
}
customElements.define("ecbf-combobox-search", $48df0946d6b0a87e$var$ComboboxSearch);



/* focusin/out event polyfill (firefox) */ !function() {
    var w = window, d = w.document;
    if (w.onfocusin === undefined) {
        d.addEventListener("focus", addPolyfill, true);
        d.addEventListener("blur", addPolyfill, true);
        d.addEventListener("focusin", removePolyfill, true);
        d.addEventListener("focusout", removePolyfill, true);
    }
    function addPolyfill(e) {
        var type = e.type === "focus" ? "focusin" : "focusout";
        var event = new CustomEvent(type, {
            bubbles: true,
            cancelable: false
        });
        event.c1Generated = true;
        e.target.dispatchEvent(event);
    }
    function removePolyfill(e) {
        if (!e.c1Generated) {
            d.removeEventListener("focus", addPolyfill, true);
            d.removeEventListener("blur", addPolyfill, true);
            d.removeEventListener("focusin", removePolyfill, true);
            d.removeEventListener("focusout", removePolyfill, true);
        }
        setTimeout(function() {
            d.removeEventListener("focusin", removePolyfill, true);
            d.removeEventListener("focusout", removePolyfill, true);
        });
    }
}();
var $fa81208e0a0a8f4a$var$myCarousel = function() {
    var carousel, slides, index, slidenav, settings, timer, setFocus, announceItem, animationSuspended;
    function forEachElement(elements, fn) {
        for(var i = 0; i < elements.length; i++)fn(elements[i], i);
    }
    function removeClass(el, className) {
        if (el.classList) el.classList.remove(className);
        else el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function hasClass(el, className) {
        if (el.classList) return el.classList.contains(className);
        else return new RegExp("(^| )" + className + "( |$)", "gi").test(el.className);
    }
    function init(set) {
        settings = set;
        carousel = document.getElementById(settings.id);
        slides = carousel.querySelectorAll(".slide");
        carousel.className = "active carousel";
        var ctrls = document.createElement("ul");
        ctrls.className = "controls";
        ctrls.innerHTML = '<li><button type="button" class="btn-prev" aria-label="Eine Folie zur\xfcck"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" aria-hidden="true" class="svg-triangle" width="24" height="24"><polygon points="0,12 24,0 24,24"/></svg></button></li><li><button type="button" class="btn-next" aria-label="Eine Folie vor"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" aria-hidden="true" class="svg-triangle" width="24" height="24"><polygon points="24,12 0,24 0,0"/></svg></button></li>';
        ctrls.querySelector(".btn-prev").addEventListener("click", function() {
            prevSlide(true);
        });
        ctrls.querySelector(".btn-next").addEventListener("click", function() {
            nextSlide(true);
        });
        carousel.appendChild(ctrls);
        if (settings.slidenav || settings.animate) {
            slidenav = document.createElement("ul");
            slidenav.className = "slidenav";
            if (settings.animate) {
                var li = document.createElement("li");
                if (settings.startAnimated) li.innerHTML = '<button data-action="stop"><span class="visually-hidden">Starte Animation </span>\uFFED</button>';
                else li.innerHTML = '<button data-action="start"><span class="visually-hidden">Stoppe Animation </span>\u25B6</button>';
                slidenav.appendChild(li);
            }
            if (settings.slidenav) forEachElement(slides, function(el, i) {
                var li = document.createElement("li");
                var klass = i === 0 ? 'class="current" ' : "";
                var kurrent = i === 0 ? ' <span class="visually-hidden">(Aktuell)</span>' : "";
                li.innerHTML = "<button " + klass + 'data-slide="' + i + '"><span class="visually-hidden">News</span> ' + (i + 1) + kurrent + "</button>";
                slidenav.appendChild(li);
            });
            slidenav.addEventListener("click", function(event) {
                var button = event.target;
                if (button.localName == "button") {
                    if (button.getAttribute("data-slide")) //stopAnimation();
                    setSlides(button.getAttribute("data-slide"), true);
                    else if (button.getAttribute("data-action") == "stop") stopAnimation();
                    else if (button.getAttribute("data-action") == "start") startAnimation();
                }
            }, true);
            carousel.className = "active carousel with-slidenav";
            carousel.appendChild(slidenav);
        }
        var liveregion = document.createElement("div");
        liveregion.setAttribute("aria-live", "polite");
        liveregion.setAttribute("aria-atomic", "true");
        liveregion.setAttribute("class", "liveregion visually-hidden");
        carousel.appendChild(liveregion);
        slides[0].parentNode.addEventListener("transitionend", function(event) {
            var slide = event.target;
            removeClass(slide, "in-transition");
            if (hasClass(slide, "current")) {
                if (setFocus) {
                    slide.setAttribute("tabindex", "-1");
                    slide.focus();
                    setFocus = false;
                }
            }
        });
        carousel.addEventListener("mouseenter", suspendAnimation);
        carousel.addEventListener("mouseleave", function(event) {
            if (animationSuspended) startAnimation();
        });
        carousel.addEventListener("focusin", function(event) {
            if (!hasClass(event.target, "slide")) suspendAnimation();
        });
        carousel.addEventListener("focusout", function(event) {
            if (!hasClass(event.target, "slide") && animationSuspended) startAnimation();
        });
        index = 0;
        setSlides(index);
        if (settings.startAnimated) timer = setTimeout(nextSlide, 5000);
    }
    function setSlides(new_current, setFocusHere, transition, announceItemHere) {
        setFocus = typeof setFocusHere !== "undefined" ? setFocusHere : false;
        announceItem = typeof announceItemHere !== "undefined" ? announceItemHere : false;
        transition = typeof transition !== "undefined" ? transition : "none";
        new_current = parseFloat(new_current);
        var length = slides.length;
        var new_next = new_current + 1;
        var new_prev = new_current - 1;
        if (new_next === length) new_next = 0;
        else if (new_prev < 0) new_prev = length - 1;
        for(var i = slides.length - 1; i >= 0; i--)slides[i].className = "slide";
        slides[new_next].className = "next slide" + (transition == "next" ? " in-transition" : "");
        slides[new_next].setAttribute("aria-hidden", "true");
        slides[new_prev].className = "prev slide" + (transition == "prev" ? " in-transition" : "");
        slides[new_prev].setAttribute("aria-hidden", "true");
        slides[new_current].className = "current slide";
        slides[new_current].removeAttribute("aria-hidden");
        if (announceItem) carousel.querySelector(".liveregion").textContent = "Folie " + (new_current + 1) + " von " + slides.length;
        if (settings.slidenav) {
            var buttons = carousel.querySelectorAll(".slidenav button[data-slide]");
            for(var j = buttons.length - 1; j >= 0; j--){
                buttons[j].className = "";
                buttons[j].innerHTML = '<span class="visually-hidden">Folie</span> ' + (j + 1);
            }
            buttons[new_current].className = "current";
            buttons[new_current].innerHTML = '<span class="visually-hidden">Folie</span> ' + (new_current + 1) + ' <span class="visually-hidden">(Aktuell)</span>';
        }
        index = new_current;
    }
    function nextSlide(announceItem) {
        announceItem = typeof announceItem !== "undefined" ? announceItem : false;
        var length = slides.length, new_current = index + 1;
        if (new_current === length) new_current = 0;
        setSlides(new_current, false, "prev", announceItem);
        if (settings.animate) timer = setTimeout(nextSlide, 5000);
    }
    function prevSlide(announceItem) {
        announceItem = typeof announceItem !== "undefined" ? announceItem : false;
        var length = slides.length, new_current = index - 1;
        if (new_current < 0) new_current = length - 1;
        setSlides(new_current, false, "next", announceItem);
    }
    function stopAnimation() {
        clearTimeout(timer);
        settings.animate = false;
        animationSuspended = false;
        _this = carousel.querySelector("[data-action]");
        _this.innerHTML = '<span class="visually-hidden">Starte Animation </span>\u25B6';
        _this.setAttribute("data-action", "start");
    }
    function startAnimation() {
        settings.animate = true;
        animationSuspended = false;
        timer = setTimeout(nextSlide, 5000);
        _this = carousel.querySelector("[data-action]");
        //console.log(_this);
        _this.innerHTML = '<span class="visually-hidden">Stoppe Animation </span>\uFFED';
        _this.setAttribute("data-action", "stop");
    }
    function suspendAnimation() {
        if (settings.animate) {
            clearTimeout(timer);
            settings.animate = false;
            animationSuspended = true;
        }
    }
    return {
        init: init,
        next: nextSlide,
        prev: prevSlide,
        goto: setSlides,
        stop: stopAnimation,
        start: startAnimation
    };
};
function $fa81208e0a0a8f4a$export$99e00de73f33b819(carouselAutostart) {
    let animate = false;
    let startAnimated = false;
    let c = new $fa81208e0a0a8f4a$var$myCarousel();
    if (carouselAutostart) {
        animate = true;
        startAnimated = true;
    }
    c.init({
        id: "carousel",
        slidenav: true,
        animate: animate,
        startAnimated: startAnimated
    });
}


parcelRequire("5AlLF");
function $80cf29548ea3ec95$export$c4035ec45ab78831() {
    let sortOption = document.querySelector("#sort"), filterLiveRegion = document.querySelector("#filter-live-region"), data, order;
    sortOption.addEventListener("change", (e)=>{
        switch(e.target.value){
            case "name-desc":
                data = "name";
                order = "desc";
                filterLiveRegion.textContent = "Sortiert nach Alphabet, absteigend";
                break;
            case "name-asc":
                data = "name";
                order = "asc";
                filterLiveRegion.textContent = "Sortiert nach Alphabet, aufsteigend";
                break;
            case "price-desc":
                data = "price";
                order = "desc";
                filterLiveRegion.textContent = "Sortiert nach Preis, absteigend";
                break;
            case "price-asc":
                data = "price";
                order = "asc";
                filterLiveRegion.textContent = "Sortiert nach Preis, aufsteigend";
                break;
            default:
                filterLiveRegion.textContent = "Keine gesonderte Sortierung";
                break;
        }
        tinysort("#produktliste li", {
            data: data,
            order: order
        });
    });
}



function $d4c66d76d832dca7$export$3132a456f5dcd746() {
    let forms = document.querySelectorAll("[data-order]"), requiredFields, emailFields, registerUserCheckBox, passwordField1, passwordField2, passwordFieldHideShows, registerUserArea;
    forms.forEach((form)=>{
        registerUserCheckBox = document.querySelector("#registerUser");
        passwordField1 = document.getElementById("logonData.loginPassword");
        passwordField1 = document.getElementById("logonData.loginPassword");
        passwordField2 = document.getElementById("logonData.loginPasswordRepeat");
        passwordFieldHideShows = document.querySelectorAll(".passwordHideShow");
        registerUserArea = document.getElementById("registerUserArea");
        registerUserCheckBox.addEventListener("change", (e)=>{
            if (e.target.checked) registerUserArea.removeAttribute("hidden");
            else registerUserArea.setAttribute("hidden", true);
        });
        /**
     * @param {HTMLElement} passwordFieldHideShow
     */ passwordFieldHideShows.forEach((passwordFieldHideShow)=>{
            /**
       * @param {Event} e
       */ passwordFieldHideShow.setAttribute("aria-pressed", "false");
            passwordFieldHideShow.addEventListener("click", (e)=>{
                /** @const {HTMLElement} */ const target = e.target;
                const liveRegion = target.nextElementSibling, passwordInput = target.previousElementSibling;
                if (passwordInput.getAttribute("type") === "password") {
                    passwordInput.setAttribute("type", "text");
                    target.setAttribute("aria-pressed", "true");
                    liveRegion.textContent = "Password sichtdata-input";
                } else {
                    passwordInput.setAttribute("type", "password");
                    target.setAttribute("aria-pressed", "false");
                    liveRegion.textContent = "Password unsichtdata-input";
                }
            });
        });
        /**
     * @param {Event} e
     */ form.addEventListener("submit", (e)=>{
            e.preventDefault();
            // requiredFields nicht cachen!
            requiredFields = document.querySelectorAll(".data-input [aria-required='true']");
            emailFields = document.querySelectorAll("input[type='email']");
            // Loope durch alle Pflichtfelder
            /**
       * @param {HTMLInputElement} requiredField
       */ requiredFields.forEach((requiredField)=>{
                // Ist "requiredField" ein Fieldset, in dem ein Input ausgewählt ist?
                let requiredFieldsetisChecked = requiredField.tagName === "FIELDSET" && requiredField.value;
                // Erkenne nicht ausgefüllte oder nicht gecheckte Pflichtfelder oder Radiogroups in Fehlerzustand
                const fieldInputEmptyThoughRequired = !requiredField.checked && requiredField.value === "" || !!requiredFieldsetisChecked;
                // Finde die ID der Fehlermeldung heraus
                let idRefRequired = requiredField.getAttribute("data-required-error");
                if (fieldInputEmptyThoughRequired) {
                    // Setze unausgefüllte Pflichtfelder in einen semantischen Fehlerzustand
                    requiredField.setAttribute("aria-invalid", "true");
                    // Assoziiere den Fehlerneldungstext
                    requiredField.setAttribute("aria-describedby", idRefRequired);
                    // Macht die Fehlermeldungen auch visuell sichtdata-input
                    document.getElementById(idRefRequired).removeAttribute("hidden");
                // Feld ausgefüllt? Dann etwaigen Fehlerzustand auflösen:
                } else {
                    // Verknüpfung mit Fehlermeldung auflösen
                    requiredField.removeAttribute("aria-describedby");
                    document.getElementById(idRefRequired).setAttribute("hidden", true);
                    // Semantischen Fehlerzustand auflösen
                    requiredField.removeAttribute("aria-invalid");
                }
                let idRefMismatch = passwordField2.getAttribute("data-pw-mismatch-error");
                // Wenn beide Passwortfelder ausgefüllt sind, aber nicht übereinstimmen:
                if (passwordField1.value && passwordField2.value && passwordField1.value !== passwordField2.value) {
                    passwordField2.setAttribute("aria-describedby", idRefMismatch);
                    passwordField2.setAttribute("aria-invalid", "true");
                    document.getElementById(idRefMismatch).removeAttribute("hidden");
                } else if (// Wenn beide Passwortfelder ausgefüllt sind und übereinstimmen:
                passwordField1.value && passwordField2.value && passwordField1.value === passwordField2.value) {
                    // Verknüpfung mit Fehlermeldung auflösen
                    passwordField2.removeAttribute("aria-describedby");
                    document.getElementById(idRefMismatch).setAttribute("hidden", true);
                    // Semantischen Fehlerzustand auflösen
                    passwordField2.removeAttribute("aria-invalid");
                }
                // Loope durch alle E-Mail-Eingabefelder
                /**
         * @param {HTMLElement} emailField
         */ emailFields.forEach((emailField)=>{
                    // Hole die ID der Fehlermeldung
                    let idRefEmail = emailField.getAttribute("data-email-syntax-error");
                    if (emailField.value && !(0, $0310234b6907e102$export$18148d12c805c5b0)(emailField.value)) {
                        // Wenn E-Mail-Adresse nicht der üblichen E-Mail-Syntax entspricht:
                        emailField.setAttribute("aria-describedby", idRefEmail);
                        document.getElementById(idRefEmail).removeAttribute("hidden");
                    } else {
                        // Wenn E-Mail der  üblichen E-Mail-Syntax entspricht:
                        emailField.removeAttribute("aria-invalid");
                        emailField.removeAttribute("aria-describedby");
                        document.getElementById(idRefEmail).hidden = true;
                    }
                });
            });
            if (!document.querySelectorAll(".data-input .form__error:not([hidden])").length) {
                window.location.href = "zusammenfassung.html";
                let address_salutation = document.querySelector('input[name="address.radiogroup.salutation"]:checked').value;
                localStorage.setItem("address.salutation", address_salutation);
                let address_firstName = document.getElementById("address.firstName").value;
                localStorage.setItem("address.firstName", address_firstName);
                let address_lastName = document.getElementById("address.lastName").value;
                localStorage.setItem("address.lastName", address_lastName);
                let address_company = document.getElementById("address.company").value;
                localStorage.setItem("address.company", address_company);
                let address_address1 = document.getElementById("address.address1").value;
                localStorage.setItem("address.address1", address_address1);
                let address_address2 = document.getElementById("address.address2").value;
                localStorage.setItem("address.address2", address_address2);
                let address_zipCode = document.getElementById("address.zipCode").value;
                localStorage.setItem("address.zipCode", address_zipCode);
                let address_city = document.getElementById("address.city").value;
                localStorage.setItem("address.city", address_city);
                let address_email = document.getElementById("address.email").value;
                localStorage.setItem("address.email", address_email);
                if (document.querySelector('input[name="addressIsInvoiceAddress"]:checked')) {
                    let addressIsInvoiceAddress = document.querySelector('input[name="addressIsInvoiceAddress"]:checked').value;
                    if (addressIsInvoiceAddress === "on") localStorage.setItem("addressIsInvoiceAddress", addressIsInvoiceAddress);
                    else localStorage.setItem("addressIsInvoiceAddress", "off");
                } else localStorage.removeItem("addressIsInvoiceAddress");
                let address_invoice_salutation = document.querySelector('input[name="address-invoice.radiogroup.salutation"]:checked').value;
                localStorage.setItem("address-invoice.salutation", address_invoice_salutation);
                let address_invoice_firstName = document.getElementById("address-invoice.firstName").value;
                localStorage.setItem("address-invoice.firstName", address_invoice_firstName);
                let address_invoice_lastName = document.getElementById("address-invoice.lastName").value;
                localStorage.setItem("address-invoice.lastName", address_invoice_lastName);
                let address_invoice_company = document.getElementById("address-invoice.company").value;
                localStorage.setItem("address-invoice.company", address_invoice_company);
                let address_invoice_address1 = document.getElementById("address-invoice.address1").value;
                localStorage.setItem("address-invoice.address1", address_invoice_address1);
                let address_invoice_address2 = document.getElementById("address-invoice.address2").value;
                localStorage.setItem("address-invoice.address2", address_invoice_address2);
                let address_invoice_zipCode = document.getElementById("address-invoice.zipCode").value;
                localStorage.setItem("address-invoice.zipCode", address_invoice_zipCode);
                let address_invoice_city = document.getElementById("address-invoice.city").value;
                localStorage.setItem("address-invoice.city", address_invoice_city);
                let address_invoice_email = document.getElementById("address-invoice.email").value;
                localStorage.setItem("address-invoice.email", address_invoice_email);
            } else {
                let errorAmount = document.querySelectorAll(".data-input .form__error:not([hidden])").length;
                // Kommuniziere, dass Eingabefehler aufgetreten sind per Dokumententitel und Live Region
                document.title = `${errorAmount} Fehler bei der Eingabe` + document.title;
                document.querySelector("#filter-live-region").textContent = `${errorAmount} Fehler bei der Eingabe`;
                // Finde das erste fehlerhafte Feld und fokussiere es
                if (document.querySelector('input[aria-invalid="true"]')) document.querySelector('input[aria-invalid="true"]').focus();
            }
        });
    });
}



var $gCiTj = parcelRequire("gCiTj");
function $3f763f07b7f268f2$export$7f9953c70dacfd7f() {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: no-preference)");
    const hasReducedMotionPreference = localStorage.getItem("animating") === "false";
    const button = document.querySelector("#festive-animation-ani-toggle");
    function mQDetection() {
        if (mediaQuery.matches) {
            document.body.classList.add("allows-animation");
            document.body.classList.add("show-animation-controls");
            localStorage.setItem("animating", "true");
        } else {
            document.body.classList.remove("allows-animation");
            document.body.classList.remove("show-animation-controls");
            localStorage.setItem("animating", "false");
        }
    }
    if (mediaQuery.matches && !hasReducedMotionPreference) {
        document.body.classList.add("allows-animation");
        document.body.classList.add("show-animation-controls");
        button.textContent = "Animation pausieren";
    } else {
        document.body.classList.remove("allows-animation");
        button.textContent = "Animation starten";
    }
    if (hasReducedMotionPreference) button.textContent = "Animation starten";
    if (localStorage.getItem("animating") === "false") {
        document.body.classList.remove("allows-animation");
        document.body.classList.add("show-animation-controls");
        button.textContent = "Animation starten";
    }
    mQDetection();
    mediaQuery.addEventListener("change", ()=>{
        mQDetection();
    });
    button.addEventListener("click", ()=>{
        if (document.body.classList.contains("allows-animation")) {
            // Animation ausstellen
            document.body.classList.remove("allows-animation");
            localStorage.setItem("animating", "false");
            button.textContent = "Animation starten";
        } else {
            // Animation anstellen
            document.body.classList.add("allows-animation");
            localStorage.setItem("animating", "true");
            button.textContent = "Animation pausieren";
        }
    });
}


// eslint-disable-next-line
const $24e87f2b64c7c1bd$var$mainSearchToggle = document.getElementById("main-search-toggle");
const $24e87f2b64c7c1bd$var$cookieModal = document.querySelector("#cookie-modal");
const $24e87f2b64c7c1bd$var$cartModal = document.querySelector("#cart-modal");
const $24e87f2b64c7c1bd$var$urlParams = new URLSearchParams(window.location.search);
// eslint-disable-next-line
const $24e87f2b64c7c1bd$var$cookieModalTrigger = document.querySelector("[data-cookie-modal-trigger]");
const $24e87f2b64c7c1bd$var$cartModalTriggers = document.querySelectorAll("[data-cart-modal-trigger]");
const $24e87f2b64c7c1bd$var$triggerBigImageDialog = document.querySelector("#trigger-big-image-dialog");
const $24e87f2b64c7c1bd$var$bigImageDialog = document.querySelector("#big-image");
// Warenkorb
(0, $gCiTj.cart)();
// eslint-disable-next-line no-undef
PetiteVue.createApp().mount("#content");
// Dialoge
if ($24e87f2b64c7c1bd$var$triggerBigImageDialog) $24e87f2b64c7c1bd$var$triggerBigImageDialog.addEventListener("click", function() {
    $24e87f2b64c7c1bd$var$bigImageDialog.showModal();
});
if ($24e87f2b64c7c1bd$var$bigImageDialog) $24e87f2b64c7c1bd$var$bigImageDialog.addEventListener("click", function(event) {
    let rect = $24e87f2b64c7c1bd$var$bigImageDialog.getBoundingClientRect();
    let isInDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
    if (!isInDialog) $24e87f2b64c7c1bd$var$bigImageDialog.close();
});
$24e87f2b64c7c1bd$var$cartModalTriggers.forEach((cartModalTrigger)=>{
    cartModalTrigger.addEventListener("click", ()=>{
        $24e87f2b64c7c1bd$var$cartModal.showModal();
    });
});
// Vermeide, dass sich der Cookie Modal per ESC schließen lässt, was das Standardverhalten bei modalen Dialogen ist
$24e87f2b64c7c1bd$var$cookieModal.addEventListener("cancel", (event)=>{
    event.preventDefault();
});
if (document.querySelector(".festive-animation")) (0, $3f763f07b7f268f2$export$7f9953c70dacfd7f)();
// Debug
if ($24e87f2b64c7c1bd$var$urlParams.get("debug") === "hauptnav") document.querySelector(".mega-menu-toggle").setAttribute("aria-expanded", "true");
if ($24e87f2b64c7c1bd$var$urlParams.get("debug") === "combobox") setTimeout(()=>{
    if (document.body.classList.contains("mobile")) {
        document.querySelector("#main-search-toggle").setAttribute("aria-expanded", "true");
        document.querySelector('[role="listbox"]').style.width = document.querySelector('[role="combobox"]').getBoundingClientRect().width + "px";
    }
    document.querySelector('[role="combobox"]').setAttribute("aria-expanded", "true");
}, 500);
if ($24e87f2b64c7c1bd$var$urlParams.get("debug") === "warenkorb") $24e87f2b64c7c1bd$var$cartModal.showModal();
if ($24e87f2b64c7c1bd$var$urlParams.get("debug") === "warenkorb-vorausgefuellt") {
    setTimeout(()=>{
        document.getElementById("produktliste").querySelectorAll("button")[6].click();
    }, 200);
    setTimeout(()=>{
        document.getElementById("produktliste").querySelectorAll("button")[0].click();
        document.getElementById("order").focus();
    }, 400);
}
if ($24e87f2b64c7c1bd$var$urlParams.get("debug") === "cookiedialog") $24e87f2b64c7c1bd$var$cookieModal.showModal();
// Erkenne die grobe Design-Ausprägung
(0, $0310234b6907e102$export$d0a8044dce8ff2fc)();
// Schließen von allen offenen Ausklappbereichen bei ESC
document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") document.querySelectorAll('[aria-expanded="true"]').forEach((disclosure)=>{
        disclosure.setAttribute("aria-expanded", "false");
    });
});
// Mein-Konto-Ausklappbereich im Header
(0, $0310234b6907e102$export$40ba32d7e7abefe9)(document.querySelector(".account--widget__button"));
if (document.getElementById("carousel") && $24e87f2b64c7c1bd$var$urlParams.get("debug") === "karussell-autostart") (0, $fa81208e0a0a8f4a$export$99e00de73f33b819)(true);
else if (document.getElementById("carousel") && $24e87f2b64c7c1bd$var$urlParams.get("debug") !== "karussell-autostart") (0, $fa81208e0a0a8f4a$export$99e00de73f33b819)();
if (document.querySelector("[data-order]")) (0, $d4c66d76d832dca7$export$3132a456f5dcd746)();
if (document.querySelector("#produktliste")) (0, $80cf29548ea3ec95$export$c4035ec45ab78831)();


//# sourceMappingURL=bestellen.85190d29.js.map
